export class Paging {
    page: number;
    pageSize: number;
    pageSizeOption: number[] = [];
    constructor() {
        this.page = 1;
        this.pageSize = 10;
        this.pageSizeOption = [2, 5, 10, 15, 25];
    }
}
